import { salesColor, salesRadius, SALES_SYMBOL_STROKE } from './store-sales-layer';

/** 참조원 금액 — 지도 심볼과 같은 축척이라 크기를 눈으로 대조할 수 있다 */
const REFERENCE_AMOUNTS = [1_000_000_000, 500_000_000, 100_000_000];

/** 참조원 오른쪽 금액 라벨이 차지하는 폭 */
const LABEL_WIDTH = 56;

interface SalesLegendProps {
  /** 집계 월 (yyyy-MM) */
  month: string;
  /** 표시 중인 심볼 수 */
  count: number;
  loading?: boolean;
}

/** 매출 비례 심볼 범례 — 원 크기 ↔ 금액 대조용 참조원 */
export function SalesLegend({ month, count, loading }: SalesLegendProps) {
  const maxRadius = salesRadius(REFERENCE_AMOUNTS[0]);
  const circleBox = maxRadius * 2 + 4;

  return (
    <div className="absolute left-3 top-16 md:top-auto md:bottom-8 z-[1000] bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-gray-200 p-3 text-xs">
      <div className="font-semibold text-gray-700 mb-0.5">
        매장 매출 <span className="font-normal text-gray-400">({month} 마감 기준)</span>
      </div>

      {loading ? (
        <div className="text-gray-400 py-1">불러오는 중…</div>
      ) : count === 0 ? (
        <div className="text-gray-400 py-1">표시할 매출이 없습니다</div>
      ) : (
        <>
          {/* 참조원은 아래를 맞춰 겹쳐 그린다 (비례 심볼 맵 관례) — 라벨은 각 원의 윗변 높이에 */}
          <div
            className="relative my-1"
            style={{ width: circleBox + LABEL_WIDTH, height: maxRadius * 2 + 14 }}
          >
            {REFERENCE_AMOUNTS.map(amount => {
              const r = salesRadius(amount);
              return (
                <div key={amount}>
                  <span
                    className="absolute rounded-full border-2"
                    style={{
                      width: r * 2,
                      height: r * 2,
                      left: circleBox / 2 - r,
                      bottom: 4,
                      borderColor: SALES_SYMBOL_STROKE,
                      backgroundColor: salesColor(amount),
                    }}
                  />
                  <span
                    className="absolute text-[10px] text-gray-600 tabular-nums translate-y-1/2 whitespace-nowrap"
                    style={{ left: circleBox + 4, bottom: r * 2 + 4 }}
                  >
                    {(amount / 100_000_000).toFixed(1)}억원
                  </span>
                </div>
              );
            })}
          </div>
          <div className="text-gray-500">{count}곳 · 원이 크고 붉을수록 매출이 큼</div>
        </>
      )}
    </div>
  );
}
